import type { EditorAPI } from '@/editorAPI';

export const openEmailMarketingPackagePicker = (
  editorAPI: EditorAPI,
  msid: string,
) => {
  const packagePickerUrl = `https://www.wix.com/wix-emails-plans?metaSiteId=${msid}`;
  window.open(packagePickerUrl, '_blank');
};
